export class ReparacionDetalle {
    idReparacionDetalle: number;
    avance: number;
    observaciones: string;
    fechaActualizacion: Date;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/reparacionDetalle.ts